import { getServerPromotionData } from "./data";

const toLowerCaseFirstLetterKeys = (obj: any): any => {
  if (Array.isArray(obj)) {
    return obj.map(toLowerCaseFirstLetterKeys);
  } else if (obj !== null && obj.constructor === Object) {
    return Object.keys(obj).reduce((acc, key) => {
      const newKey = key.charAt(0).toLowerCase() + key.slice(1);
      acc[newKey] = toLowerCaseFirstLetterKeys(obj[key]);
      return acc;
    }, {} as any);
  }
  return obj;
};
const getIsInTimeWindow = (from?: string, until?: string) => {
  if (!from || !until) return false;
  const fromDate = new Date(from).getTime();
  const toDate = new Date(until).getTime();
  const now = new Date().getTime();

  return now > fromDate && now < toDate;
};

function getPromotionFromDOM(): LowercasePromotion | null {
  const promotionElement = document.querySelector("[data-promotion]");
  if (!promotionElement) return null;

  const promotionData = promotionElement.getAttribute("data-promotion");
  if (!promotionData) return null;

  const promotion: Strapi.Promotion = JSON.parse(promotionData);

  return toLowerCaseFirstLetterKeys(promotion) as LowercasePromotion;
}

function getPromotionServerVariable(): LowercasePromotion | null {
  const promotion = getServerPromotionData();
  if (!promotion) return null;

  return toLowerCaseFirstLetterKeys(promotion) as LowercasePromotion;
}

function getActivePromotion(promotion: LowercasePromotion | null): LowercasePromotion | null {
  if (!promotion) return null;
  const { activeFrom, activeUntil } = promotion;
  const isActive = getIsInTimeWindow(activeFrom, activeUntil);
  return isActive ? promotion : null;
}

const getPromotionData = import.meta.env.SSR ? getPromotionServerVariable : getPromotionFromDOM;
const getActivePromotionData = () => getActivePromotion(getPromotionData());

export { getPromotionData, getActivePromotionData };
